import Vue from 'vue'
import Router from 'vue-router'
import { i18n } from '../i18n'

// Containers
import DefaultContainer from '@/containers/DefaultContainer'
import DetailContainer from '@/containers/DetailContainer'
import SubContainer from '@/containers/SubContainer'
import MaintenanceContainer from '@/containers/MaintenanceContainer'

// Views
import Main from '@/views/Main'
import Category from '@/views/shop/Category'
import ProductView from '@/views/shop/ProductView'
import MyShopping from '@/views/my/MyShopping'
import Cart from '@/views/cart/Cart'
import Recent from '@/views/recent/Recent'
import Coupon from '@/views/my/Coupon'
import CouponUsable from '@/views/my/CouponUsable'
import CouponUnusable from '@/views/my/CouponUnusable'
import CouponView from '@/views/my/CouponView'
/* import History from '@/views/my/History' */
import PurchaseList from '@/views/my/PurchaseList'
import PurchaseView from '@/views/my/PurchaseView'
import AlltemPurchaseDetail from '@/views/my/AlltemPurchaseDetail'
import CancelList from '@/views/my/CancelList'
import CancelView from '@/views/my/CancelView'
import CancelApply from '@/views/my/CancelApply'
import RewardInfo from '@/views/my/RewardInfo'
import RewardView from '@/views/my/RewardView'
import RewardIntro from '@/views/my/RewardIntro'
import Order from '@/views/order/Order'
import OrderComplete from '@/views/order/OrderComplete'
import MaintenanceView from '@/views/MaintenanceView'

import Search from '@/views/search/Search'
import SearchProducts from '@/views/search/SearchProducts'
import SearchTag from '@/views/search/SearchTag'
import TagList from '@/views/search/TagList'
import ErrorPage from '@/views/base/ErrorPage'
import CharacterSetting from '@/views/characters/CharacterSetting'

// store
import store from '@/store'
import {
  isLogin,
  beforeSendLog,
  isIOSChrome,
  isLegacyIntro,
  isLegacyURL,
  getBaseInfo,
  redirectToHit2IfJPIntro
} from '@/utils'
import { setExceptedGamesToSessionStorage } from '@/utils/exceptionGame.js'

Vue.use(Router)

if (isLegacyIntro()) {
  location.href = `${location.origin}/kr/intro.html`
}

if (isLegacyURL()) {
  const currentURL = new URL(location.href)
  const query = currentURL.search

  if (currentURL.pathname.indexOf('hittheworld') > -1) {
    const newURL = `${currentURL.origin}/jp${currentURL.pathname}${query}`

    if (currentURL.pathname.indexOf('/jp') > -1) {
      history.replaceState(null, '', newURL)
    } else {
      location.href = newURL
    }
  } else {
    const newURL = `${currentURL.origin}/kr${currentURL.pathname}${query}`
    history.replaceState(null, '', newURL)
  }
}

redirectToHit2IfJPIntro()

const { base, nationPath } = getBaseInfo()

i18n.locale = nationPath === 'kr' ? 'ko' : 'ja'

document.documentElement.lang = i18n.locale

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  base,
  scrollBehavior(to, from, savedPosition) {
    if (
      (from.name === 'main' && to.name === 'category') ||
      (from.name === 'category' && to.name === 'main')
    ) {
      return { y: 0 }
    } else {
      return savedPosition || { y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/main',
      component: DefaultContainer,
      children: [
        {
          path: 'main',
          name: 'main',
          component: Main
        },
        {
          path: 'category/:categoryId',
          name: 'category',
          component: Category,
          props: true
        }
      ]
    },
    {
      path: '/',
      component: DetailContainer,
      children: [
        {
          path: 'product/:productId',
          name: 'product',
          component: ProductView,
          props: route => ({
            productId: route.params.productId,
            og: route.query.og
          })
        },
        {
          path: 'cart',
          name: 'cart',
          component: Cart,
          meta: { requiresAuth: true }
        },
        {
          path: 'order',
          name: 'order',
          component: Order,
          meta: { requiresAuth: true },
          props: true
        },
        {
          path: 'orderComplete/:token',
          name: 'orderComplete',
          component: OrderComplete,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'errorPage',
          name: 'errorPage',
          component: ErrorPage,
          props: true
        }
      ]
    },
    {
      path: '/',
      component: SubContainer,
      children: [
        {
          path: 'my',
          name: 'my',
          component: MyShopping
        },
        {
          path: 'recent',
          name: 'recent',
          component: Recent
        },
        {
          path: 'characters',
          name: 'characters',
          component: CharacterSetting
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: Coupon,
          redirect: 'coupon/usable',
          meta: { requiresAuth: true },
          children: [
            {
              path: 'usable',
              name: 'coupon-usable',
              component: CouponUsable
            },

            {
              path: 'unusable',
              name: 'coupon-unusable',
              component: CouponUnusable
            }
          ]
        },
        {
          path: 'couponView/:couponId',
          name: 'couponView',
          component: CouponView,
          meta: { requiresAuth: true },
          props: route => ({ couponId: Number(route.params.couponId) })
        },
        {
          path: 'purchase',
          name: 'purchase',
          component: PurchaseList,
          meta: { requiresAuth: true }
        },
        {
          path: 'purchaseView/:purchaseId',
          name: 'purchaseView',
          component: PurchaseView,
          meta: { requiresAuth: true },
          props: route => ({ purchaseId: Number(route.params.purchaseId) })
        },
        {
          path: 'purchaseDetail',
          name: 'alltemPurchaseDetail',
          component: AlltemPurchaseDetail,
          meta: { requiresAuth: true },
          props: route => ({
            ...route.params
          })
        },
        {
          path: 'cancel',
          name: 'cancel',
          component: CancelList,
          meta: { requiresAuth: true }
        },
        {
          path: 'cancelView/:purchaseId',
          name: 'cancelView',
          component: CancelView,
          meta: { requiresAuth: true },
          props: route => ({ purchaseId: Number(route.params.purchaseId) })
        },
        {
          path: 'cancelApply/:couponId',
          name: 'cancelApply',
          component: CancelApply,
          props: route => ({
            coupon: route.params.coupon,
            couponId: Number(route.params.couponId)
          }),
          meta: { requiresAuth: true }
        },
        {
          path: 'reward',
          name: 'reward',
          component: RewardInfo,
          meta: { requiresAuth: true }
        },
        {
          path: 'rewardView/:rewardYearMonth',
          name: 'rewardView',
          component: RewardView,
          meta: { requiresAuth: true },
          props: route => ({
            rewardYearMonth: Number(route.params.rewardYearMonth)
          })
        },
        {
          path: 'rewardIntro',
          name: 'rewardIntro',
          component: RewardIntro
        },
        {
          path: 'search',
          name: 'search',
          component: Search,
          children: [
            {
              path: 'product/:query',
              name: 'search-product',
              component: SearchProducts
            },

            {
              path: 'tag/:query',
              name: 'search-tag',
              component: SearchTag
            }
          ]
        },
        {
          path: 'tagList/:query',
          name: 'tagList',
          component: TagList,
          props: true
        }
      ]
    },
    {
      path: '/',
      component: MaintenanceContainer,
      children: [
        {
          path: '/maintenance',
          name: 'MaintenanceView',
          component: MaintenanceView
        }
      ]
    },
    {
      path: '*',
      redirect: '/main'
    }
  ]
})

/**
 * beforeEnter에서 next 함수를 호출하기 전 호출한다.
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
const beforeNext = (to, from, next) => {
  let subtitle = '',
    buttonType = '',
    showPrevButton = true,
    requestPossible = true
  const option = {}
  switch (to.name) {
    case 'maintenance':
      break
    case 'main':
    case 'category':
      if (from.name === 'product') {
        requestPossible = false
      }
      buttonType = 'search'

      // A2S
      if (to.name === 'category') {
        option.CategoryID = to.params.categoryId
      }

      break
    case 'product':
      buttonType = 'cart'

      // A2S
      option.ProductID = to.params.productId
      break
    case 'cart':
      subtitle = i18n.t('nav.title.cart')
      buttonType = 'home'
      break
    case 'order':
      // for iOS kakaopay error
      if (isIOSChrome()) {
        const forceReload = sessionStorage.getItem('forceReload')
        if (
          forceReload !== 'true' &&
          typeof to.params.productList !== 'undefined' &&
          to.params.productList.length
        ) {
          const productList = to.params.productList
            .reduce((acc, val) => {
              return `${acc}||${JSON.stringify(val)}`
            }, '')
            .slice(2)

          sessionStorage.setItem('fromView', to.params.fromView === true)
          sessionStorage.setItem('productList', productList)
        } else if (
          forceReload === 'true' &&
          sessionStorage.getItem('productList') !== null
        ) {
          const productList = sessionStorage
            .getItem('productList')
            .split('||')

            .map(el => JSON.parse(el))
          to.params.productList = productList
          to.params.fromView = sessionStorage.getItem('fromView') === 'true'

          sessionStorage.removeItem('fromView')
          sessionStorage.removeItem('productList')
        }
      }

      if (!to.params.productList) {
        let obj = { name: from.name || 'main' }
        if (/product|order/gi.test(obj.name)) obj.name = 'main'

        store.dispatch('modal/openModal', {
          type: 'alert',
          message: i18n.t('alert.invalid_access_G01')
        })
        return next({ ...obj, replace: true })
      }

      subtitle = i18n.t('nav.title.order')

      // 응모 상품 title 변경
      if (to.params.productList[0] && to.params.productList[0].type === 7) {
        subtitle = i18n.t('nav.title.apply')
      }

      buttonType = 'home'
      break
    case 'orderComplete':
      subtitle = i18n.t('nav.title.order_complete')

      // 응모 상품 title 변경
      if (
        to.params.productList &&
        to.params.productList[0] &&
        to.params.productList[0].type === 7
      ) {
        subtitle = i18n.t('nav.title.apply_complete')
      }

      buttonType = 'home'
      showPrevButton = false
      break
    case 'my':
      subtitle = i18n.t('nav.title.my_C01')
      buttonType = 'home'
      break
    case 'characters':
      subtitle = i18n.t('nav.title.set_character_D07')
      buttonType = ''
      break
    case 'recent':
      subtitle = i18n.t('nav.title.recent_product_D01')
      buttonType = 'search'
      break
    case 'coupon-usable':
    case 'coupon-unusable':
      if (from.name === 'couponView') {
        requestPossible = false
      }
      subtitle = i18n.t('nav.title.my_coupon')
      break
    case 'couponView':
      subtitle = i18n.t('nav.title.coupon_detail')
      buttonType = 'cart'
      break
    case 'purchase':
      if (from.name !== 'purchaseView') {
        store.dispatch('datepicker/setInit')
      }
      subtitle = i18n.t('nav.title.purchase')
      break
    case 'purchaseView':
      subtitle = i18n.t('nav.title.purchase_detail')
      option.ProductID = to.params.purchaseId
      break
    case 'alltemPurchaseDetail':
      subtitle = i18n.t('nav.title.purchase_detail')
      option.ShopId = to.params.shopId
      break
    case 'cancel':
      if (from.name !== 'cancelView') {
        store.dispatch('datepicker/setInit')
      }
      subtitle = i18n.t('nav.title.cancel')
      break
    case 'cancelView':
      subtitle = i18n.t('nav.title.cancel_detail')
      break
    case 'cancelApply':
      subtitle = i18n.t('nav.title.cancel_request')
      break
    case 'reward':
    case 'rewardIntro':
      if (!store.getters['main/enableReward']) {
        next({ name: 'my', replace: true })
      }
      subtitle = i18n.t('nav.title.reward')
      break
    case 'rewardView':
      if (!store.getters['main/enableReward']) {
        next({ name: 'my', replace: true })
      }
      subtitle = i18n.t('nav.title.point_detail')
      break
    case 'tagList':
      subtitle = `#${to.params.query}`
      break
    case 'errorPage':
      subtitle = i18n.t('nav.title.error')
      showPrevButton = false
      break
    case 'search-tag':
    case 'search-product':
      // 뒤로가기로 진입한 경우에 검색이 안되는 버그가 발생하여 목록을 체크한다.
      if (
        (from.name === 'product' || from.name === 'tagList') &&
        store.getters[
          `search/${to.name === 'search-tag' ? 'tagList' : 'productList'}`
        ].length
      ) {
        requestPossible = false
      }
      break
  }

  if (store.getters['main/requestPossible'] != requestPossible)
    store.dispatch('main/setRequestPossible', requestPossible)
  if (store.getters['header/subtitle'] != subtitle)
    store.dispatch('header/setSubtitle', subtitle)
  if (store.getters['header/buttonType'] != buttonType)
    store.dispatch('header/setButtonType', buttonType)
  if (store.getters['header/showPrevButton'] != showPrevButton)
    store.dispatch('header/showPrevButton', showPrevButton)

  if (store.getters['api/isCalling'] === true) {
    store.dispatch('api/clearAllRequest')
  }

  next()

  // A2S
  beforeSendLog('', option, 'contents')

  // gtag pageview
  gtag('event', 'page_view', { page_path: location.pathname })
}

router.beforeEach((to, from, next) => {
  setExceptedGamesToSessionStorage()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 이 라우트는 인증이 필요하며 로그인 한 경우 확인하십시오.
    // 그렇지 않은 경우 로그인 페이지로 리디렉션하십시오.
    if (isLogin() === false) {
      store.dispatch('modal/openModalLogin', from.name == null ? to.name : '', {
        root: true
      })
    } else {
      beforeNext(to, from, next)
    }
  } else {
    beforeNext(to, from, next)
  }
})

export default router
